import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/dialog-sc-opt-out-arbitration.json'
import Button from 'src/components/Button'

import classes from '../styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  onClick: () => void
}

export default function OptOutButton(props: Props) {
  return (
    <>
      <p className='mt-typography-body1'>{t('step1')}</p>
      <Button className={classes.btnRequest} type='submit' onClick={props.onClick}>
        {t('btn_request')}
      </Button>
    </>
  )
}
